// src/App.jsx
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import Bootcamp from "./pages/Bootcamp";

// Fonction utilitaire pour détecter le sous-domaine
function getSubdomain() {
  const host = window.location.hostname;
  const parts = host.split(".");
  // Si le domaine est du type bootcamp.impact-founders.com
  if (parts.length > 2) {
    return parts[0];
  }
  return null;
}


function App() {

  const subdomain = getSubdomain();

  // Si on est sur bootcamp.impact-founders.com, affiche Bootcamp.jsx sur "/"
  if (subdomain === "bootcamp") {
    return (
      <Router>
        <Routes>
          <Route path="*" element={<Bootcamp />} />
        </Routes>
      </Router>
    );
  }


  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
